<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg6>          
            <v-card pa-0>              
              <v-divider></v-divider>
              <v-card-text class="">
                <v-form v-model="valid">
                  <v-layout row wrap>                        
                    <v-flex sm12 lg12>
                      <v-text-field
                        style="width:140px;"
                        label="Nomor"                                                  
                        v-model="formModel.no"
                        v-validate="'required'"
                        data-vv-name="no"     
                        :error-messages="errors.collect('no')"  
                        required
                      ></v-text-field>
                      <v-text-field
                        label="Quetion"                                                  
                        v-model="formModel.question"
                        v-validate="'required'"
                        data-vv-name="quetion"     
                        :error-messages="errors.collect('quetion')"  
                        required
                      ></v-text-field>
                      <v-radio-group label="type :" v-model="formModel.type" row
                        data-vv-name="type" v-validate="'type'"    
                        :error-messages="errors.collect('type')">
                        <v-radio label="Optional" :value="1"></v-radio>
                        <v-radio label="Additional" :value="2"></v-radio>            
                        <v-radio label="Isian" :value="3"></v-radio>            
                      </v-radio-group>
                      <div class="v-table__overflow tabular">
                        <v-btn @click="newOption()" icon class="primary--text mb-2" style="position: absolute; right:15px; " ><v-icon>add</v-icon></v-btn>                                           
                        <v-data-table
                          v-bind:headers="option.headers"
                          v-bind:items="formModel.option"
                          hide-actions class="elevation-1 tabular" 
                        >
                          <template slot="items" slot-scope="props" >
                            <td style="width:180px">
                              <v-text-field
                                solo hide-details
                                type="text"
                                v-model="props.item.no"
                                label="Answer"                                      
                              ></v-text-field>                           
                            </td>                          
                            <td>
                              <v-text-field
                                solo hide-details
                                type="text"
                                v-model="props.item.answer"
                                label="Answer"      
                                style="with:300px"                              
                              ></v-text-field>                            
                            </td>                            
                            <td style="width:1%">                                    
                              <v-btn v-on:click="delOption(props)" icon class="pink--text" small>
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </td>   
                          </template>  
                        </v-data-table>
                      </div>  
                    </v-flex>
                    <div class="form-btn">
                      <v-btn v-if="!isUpdate" @click="save(isUpdate)" color="success">Create</v-btn>
                      <v-btn v-else @click="save(isUpdate)" color="primary">Update</v-btn>                                                                    
                      <v-btn outline @click="clear">Clear</v-btn>
                    </div>  
                  </v-layout>                                                            
                </v-form>  
              </v-card-text>       
            </v-card>
          </v-flex>                   
        </v-layout>
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model  from '@/apps/admin/models/Quetionnaire';    
import moment from 'moment';

var model = new Model();

export default {
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({
        isEditing:true,
        isUpdate:false,
        id: null,
        nama:null,

        formModel: { 
          no : null,
          question : null,
          type : null,
          option : [],
        },
        //countries: Countries,
        balance: [],    
        valid: true,
        option:{
          headers:[
             { text: 'No', value: 'no', sortable:false  },
             { text: 'Answer', value: 'answer', sortable:false  },
             { text: '', value: 'action', sortable:false  },
          ],
        },
    }),
   // created () {this.getParents()},    
    mounted () {this.init();}, 
    methods : {
        init(){
            if(this.$route.query.id){
                this.isUpdate  = true;
                model.one({id : this.$route.query.id }).then(data => {                     
                    Object.assign(this.formModel, data === null ? {}:data);                                  
                    this.checking(data);
                });                                               
            }
            
            this.$validator.localize('en', this.dictionary);       
        },
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            this.formModel.time = moment().valueOf();
            this.formModel.info = null;
            if( !this.errors.any() ) {
                var res = isUpdate ? await model.update(this.formModel): await model.create(this.formModel);                
                if(res.status === 200){   
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$router.go(-1);                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                }
            }             
        },
       
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
                
        checking(data){
            if(data.info){
                if(data.info.action === 'synch' && data.info.data){
                    this.validate(data.info.data);
                }
            }            
        },        
                
        clear () {
            this.formModel = {};
            this.$validator.reset();
        },
    
        customFilter (item, queryText, itemText) {
            const textOne = item.nama.toLowerCase()
            //const textTwo = item.abbr.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1; 
        },    
        
        newOption(){
          this.formModel.option.push({no : null, answer: null});
        },

        delOption(props){            
          this.formModel.option.splice(props.index, 1);   
          //this.detail.splice(props.index, 1);   
        },
        
    }
}
</script>